import { Views } from './types';
var getFromLocalStorage = function getFromLocalStorage(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (_unused) {
    return null;
  }
};

// Dermines if account has solutions installed with both new and legacy client portals
// If so, determines view rendered based on local storage flag
export var useClientPortalView = function useClientPortalView(views) {
  if (!views) {
    return undefined;
  }
  var legacyClientDashboardView = views.find(function (view) {
    return view.id === Views.LEGACYCLIENTDASHBOARD;
  });
  var clientPortalView = views.find(function (view) {
    return view.id === Views.CLIENTPORTAL;
  });
  if (!legacyClientDashboardView || !clientPortalView) {
    return undefined;
  }
  var prioritizeNew = !!getFromLocalStorage('opt-in-to-new-dashboard') || false;
  var prioritizeLegacy = !!getFromLocalStorage('opt-out-of-new-dashboard') || false;
  if (!prioritizeNew && !prioritizeLegacy) {
    // Default to new portal if no preference set
    return clientPortalView;
  }
  return prioritizeNew ? clientPortalView : legacyClientDashboardView;
};